var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 2 }
            },
            [
              _c("el-step", { attrs: { title: "空运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "增值服务" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "托运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "确认委托" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "委托完成" } })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", {
            staticStyle: { display: "-webkit-flex", "align-items": "center" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "70px"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerContact",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerTel",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "委托公司" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.namec,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Authorization, "namec", $$v)
                                  },
                                  expression: "Authorization.namec"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.pickFeeForAir.pickUpdate
                        ? _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "提货时间" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      disabled: "",
                                      placeholder: "选择日期",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value: _vm.pickFeeForAir.pickUpdate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pickFeeForAir,
                                          "pickUpdate",
                                          $$v
                                        )
                                      },
                                      expression: "pickFeeForAir.pickUpdate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.pickFeeForAir.checked
                        ? _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "入仓时间" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "选择日期",
                                      "picker-options": _vm.pickerSetTime
                                    },
                                    model: {
                                      value: _vm.inwarehousetime,
                                      callback: function($$v) {
                                        _vm.inwarehousetime = $$v
                                      },
                                      expression: "inwarehousetime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pickFeeForAir.checked,
                  expression: "pickFeeForAir.checked"
                }
              ],
              staticClass: "Item_list"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "padding-left": "30px",
                    "box-sizing": "border-box"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.pickFeeForAir.name,
                          expression: "pickFeeForAir.name"
                        }
                      ],
                      staticClass: "thatpoperWrap",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("div", { staticClass: "popWrap_l" }, [
                        _c("p", { staticClass: "lianxiren" }, [
                          _vm._v(_vm._s(_vm.pickFeeForAir.name))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-left": "12px" } }, [
                          _vm._v(_vm._s(_vm.pickFeeForAir.tel))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "overText",
                            staticStyle: { "margin-left": "20px" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.pickFeeForAir.parvince) +
                                _vm._s(_vm.pickFeeForAir.city) +
                                _vm._s(_vm.pickFeeForAir.area) +
                                _vm._s(_vm.pickFeeForAir.address) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.pickFeeForAir.checked,
                            expression: "!pickFeeForAir.checked"
                          }
                        ]
                      },
                      _vm._l(_vm.TipopList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "poperWrap",
                            staticStyle: { "margin-top": "20px" },
                            on: {
                              click: function($event) {
                                return _vm.changeTiitem(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "popWrap_l" }, [
                              _c("p", { staticClass: "lianxiren" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "margin-left": "12px" } },
                                [_vm._v(_vm._s(item.tel))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "overText",
                                  staticStyle: { "margin-left": "20px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.parvince) +
                                      _vm._s(item.city) +
                                      _vm._s(item.area) +
                                      _vm._s(item.address) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "popWrap_R" },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.isdefault,
                                        expression: "item.isdefault"
                                      }
                                    ],
                                    staticClass: "morentype"
                                  },
                                  [_vm._v("默认地址")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isdefault,
                                        expression: "!item.isdefault"
                                      }
                                    ],
                                    staticStyle: { color: "#604aff" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.changeshowType(
                                          2,
                                          item,
                                          "ajax"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("设为默认地址")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#604aff" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.UpItem(2, item)
                                      }
                                    }
                                  },
                                  [_vm._v("修改")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.TipopList.length > 1 && !_vm.pickFeeForAir.checked,
                      expression:
                        "TipopList.length > 1 && !pickFeeForAir.checked"
                    }
                  ],
                  staticStyle: { margin: "10px 0 0 30px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "#9a9a9a" },
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          _vm.showTi = !_vm.showTi
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.showTi ? "收起更多" : "更多提货人信息"))]
                  ),
                  _c("span", {
                    class: _vm.showTi
                      ? "el-icon-arrow-up"
                      : "el-icon-arrow-down"
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _vm._m(2),
                _vm._v(" "),
                !_vm.sendFeeForAir.checked
                  ? _c(
                      "span",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.addNewpop(3)
                              }
                            }
                          },
                          [_vm._v("新增收货人")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.sendFeeForAir.name,
                        expression: "!sendFeeForAir.name"
                      }
                    ],
                    staticClass: "poperWrap"
                  },
                  [_vm._v("\n            暂无默认联系人请添加\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sendFeeForAir.name,
                        expression: "sendFeeForAir.name"
                      }
                    ],
                    staticClass: "thatpoperWrap",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c("div", { staticClass: "popWrap_l" }, [
                      _c("p", { staticClass: "lianxiren" }, [
                        _vm._v(_vm._s(_vm.sendFeeForAir.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-left": "12px" } }, [
                        _vm._v(_vm._s(_vm.sendFeeForAir.tel))
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "overText",
                          staticStyle: { "margin-left": "20px" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sendFeeForAir.country) +
                              _vm._s(_vm.sendFeeForAir.city) +
                              _vm._s(_vm.sendFeeForAir.area) +
                              _vm._s(_vm.sendFeeForAir.address) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.sendFeeForAir.checked
                      ? _c(
                          "div",
                          { staticClass: "popWrap_R" },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.sendFeeForAir.isdefault,
                                    expression: "sendFeeForAir.isdefault"
                                  }
                                ],
                                staticClass: "morentype"
                              },
                              [_vm._v("默认地址")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.sendFeeForAir.isdefault,
                                    expression: "!sendFeeForAir.isdefault"
                                  }
                                ],
                                staticStyle: { color: "#604aff" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.changeshowType(
                                      3,
                                      _vm.sendFeeForAir,
                                      "loca"
                                    )
                                  }
                                }
                              },
                              [_vm._v("设为默认地址")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#604aff" },
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.UpItem(3, _vm.sendFeeForAir)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("el-collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showReceive,
                          expression: "showReceive"
                        }
                      ]
                    },
                    _vm._l(_vm.SHpopList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "poperWrap",
                          staticStyle: { "margin-top": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.changeShitem(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(item.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "overText",
                                staticStyle: { "margin-left": "20px" }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.country) +
                                    _vm._s(item.city) +
                                    _vm._s(item.area) +
                                    _vm._s(item.address) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "popWrap_R" },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.isdefault,
                                      expression: "item.isdefault"
                                    }
                                  ],
                                  staticClass: "morentype"
                                },
                                [_vm._v("默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.isdefault,
                                      expression: "!item.isdefault"
                                    }
                                  ],
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeshowType(3, item, "ajax")
                                    }
                                  }
                                },
                                [_vm._v("设为默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.UpItem(3, item)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.SHpopList.length > 1 && !_vm.sendFeeForAir.checked,
                    expression: "SHpopList.length > 1 && !sendFeeForAir.checked"
                  }
                ],
                staticStyle: { margin: "10px 0 0 30px" }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#9a9a9a" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        _vm.showReceive = !_vm.showReceive
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.showReceive ? "收起更多" : "更多收货人信息")
                    )
                  ]
                ),
                _c("span", {
                  class: _vm.showReceive
                    ? "el-icon-arrow-up"
                    : "el-icon-arrow-down"
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "span",
                  { staticStyle: { float: "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#604aff" },
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.addNewpop(1)
                          }
                        }
                      },
                      [_vm._v("新增发货人")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_S.name == "",
                        expression: "countLIst_S.name == ''"
                      }
                    ],
                    staticClass: "poperWrap"
                  },
                  [_vm._v("\n            暂无默认联系人请添加\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_S.name,
                        expression: "countLIst_S.name"
                      }
                    ],
                    staticClass: "thatpoperWrap",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c("div", { staticClass: "popWrap_l" }, [
                      _c("p", { staticClass: "lianxiren" }, [
                        _vm._v(_vm._s(_vm.countLIst_S.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-left": "12px" } }, [
                        _vm._v(_vm._s(_vm.countLIst_S.tel))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "popWrap_R" },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.countLIst_S.isdefault,
                                expression: "countLIst_S.isdefault"
                              }
                            ],
                            staticClass: "morentype"
                          },
                          [_vm._v("默认地址")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.countLIst_S.isdefault,
                                expression: "!countLIst_S.isdefault"
                              }
                            ],
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.changeshowType(
                                  1,
                                  _vm.countLIst_S,
                                  "loca"
                                )
                              }
                            }
                          },
                          [_vm._v("设为默认地址")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.UpItem(1, _vm.countLIst_S)
                              }
                            }
                          },
                          [_vm._v("修改")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFa,
                          expression: "showFa"
                        }
                      ]
                    },
                    _vm._l(_vm.FapopList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "poperWrap",
                          staticStyle: { "margin-top": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.changeFAitem(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(item.tel))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "popWrap_R" },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.isdefault,
                                      expression: "item.isdefault"
                                    }
                                  ],
                                  staticClass: "morentype"
                                },
                                [_vm._v("默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.isdefault,
                                      expression: "!item.isdefault"
                                    }
                                  ],
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeshowType(1, item, "ajax")
                                    }
                                  }
                                },
                                [_vm._v("设为默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.UpItem(1, item)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.FapopList.length > 1,
                    expression: "FapopList.length > 1"
                  }
                ],
                staticStyle: { margin: "10px 0 0 30px" }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#9a9a9a" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        _vm.showFa = !_vm.showFa
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.showFa ? "收起更多" : "更多发货人信息"))]
                ),
                _c("span", {
                  class: _vm.showFa ? "el-icon-arrow-up" : "el-icon-arrow-down"
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.pickFeeForAir.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.cangkuitem.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.cangkuitem.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.cangkuitem.country) +
                                    _vm._s(_vm.cangkuitem.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.sendFeeForAir.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.description.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.description.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.description.country) +
                                    _vm._s(_vm.description.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c("div", { staticStyle: { "margin-top": "20px" } }, [
                  _c(
                    "div",
                    { staticClass: "popWrap_l" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticStyle: { width: "100%" },
                          attrs: { "label-width": "80px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发货备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.remarks.remarkForSend,
                                  callback: function($$v) {
                                    _vm.$set(_vm.remarks, "remarkForSend", $$v)
                                  },
                                  expression: "remarks.remarkForSend"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "收货备注" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.remarks.remarkForReceive,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.remarks,
                                      "remarkForReceive",
                                      $$v
                                    )
                                  },
                                  expression: "remarks.remarkForReceive"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.pickFeeForAir.checked
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "提货备注" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.remarks.remarkForPick,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.remarks,
                                          "remarkForPick",
                                          $$v
                                        )
                                      },
                                      expression: "remarks.remarkForPick"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("feeDetail", {
          attrs: {
            auto_fixed: _vm.auto_fixed,
            allMoreFeeInfo: _vm.allMoreFeeInfo,
            transportFeeForAir: _vm.transportFeeForAir,
            pickFeeForAir: _vm.pickFeeForAir,
            sendFeeForAir: _vm.sendFeeForAir,
            currencyCollection: _vm.currencyCollection,
            calculatePrice: _vm.calculatePrice,
            feeList: _vm.feeList
          },
          on: { pathToback: _vm.pathToback, pathToNext: _vm.pathToNext }
        }),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "dialog",
            attrs: {
              width: _vm.width,
              visible: _vm.dialogTableVisible,
              closeOnClickModal: false
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogTableVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "wrap_count" }, [
              _c("div", { staticClass: "header_logo" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(!this.itemid ? "新增地址" : "修改地址") +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "count" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "80px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入姓名" },
                            model: {
                              value: _vm.fromPop.name,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "name", $$v)
                              },
                              expression: "fromPop.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入联系方式" },
                            model: {
                              value: _vm.fromPop.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "tel", $$v)
                              },
                              expression: "fromPop.tel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 2,
                              expression: "changeNum == 2"
                            }
                          ],
                          attrs: { label: "联系地址" }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.Guojialist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 3,
                              expression: "changeNum == 3"
                            }
                          ],
                          attrs: { label: "联系地址" }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.citylist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum != 1,
                              expression: "changeNum != 1"
                            }
                          ]
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入详细地址",
                              type: "textarea"
                            },
                            model: {
                              value: _vm.fromPop.address,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "address", $$v)
                              },
                              expression: "fromPop.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "type" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.fromPop.isdefault,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "isdefault", $$v)
                                },
                                expression: "fromPop.isdefault"
                              }
                            },
                            [
                              _c("el-checkbox", { attrs: { name: "type" } }, [
                                _vm._v("设置为默认地址")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v(_vm._s(_vm.itemid ? "修改" : "确定新增"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialogTableVisible = false
                                }
                              }
                            },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "-webkit-flex",
          "align-items": "center",
          "margin-bottom": "20px"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../../assets/weituo.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "tittype" }, [_vm._v("委托信息")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c("div", { staticClass: "count_center" }, [
          _c("img", {
            attrs: { src: require("../../assets/tihuo.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tittype", staticStyle: { color: "#333" } }, [
            _vm._v("提货信息")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "count_center" }, [
      _c("img", {
        attrs: { src: require("../../assets/shouhuo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "tittype" }, [_vm._v("收货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "count_center" }, [
      _c("img", { attrs: { src: require("../../assets/fahuo.png"), alt: "" } }),
      _vm._v(" "),
      _c("p", { staticClass: "tittype" }, [_vm._v("发货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              background: "#ffe9c7",
              padding: "8px 30px"
            }
          },
          [
            _c(
              "p",
              {
                staticClass: "tittype",
                staticStyle: {
                  padding: "0 5px",
                  color: "#c19822",
                  "font-size": "16px"
                }
              },
              [_vm._v("\n              请将货物送至以下仓库\n            ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              background: "#ffe9c7",
              padding: "8px 30px"
            }
          },
          [
            _c(
              "p",
              {
                staticClass: "tittype",
                staticStyle: {
                  padding: "0 5px",
                  color: "#c19822",
                  "font-size": "16px"
                }
              },
              [
                _vm._v(
                  "\n              请到以下目的地仓库提取货物\n            "
                )
              ]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c("div", { staticClass: "count_center" }, [
          _c("img", {
            attrs: { src: require("../../assets/ps.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tittype" }, [_vm._v("备注")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7d7ee04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7d7ee04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/AirConsignment.vue
// module id = null
// module chunks = 